module.exports = __webpack_public_path__ + "static/media/Grupos-de-Vida2.dcc843ed.jpg";